import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, Renderer, ChangeDetectorRef } from "@angular/core";
import { AuthorizationPipe } from "../../common/pipes/authorization.pipe";
import { SearchModel } from "../interface/ticketingsystem/search.model";
import { CustomerService } from "../services/customer.service";
import { WorkTicket } from "../interface/ticketingsystem/work-ticket";
import { LocalStorageService } from 'angular-2-local-storage/dist/local-storage.service';
import { SearchCriteria } from "../interface/search-criteria";
import { SearchRequest } from "../interface/search-request"; // API Request Model
import { PaginationInstance } from 'ngx-pagination';
import { MessageService } from "../../shared/services/message.service";
import { DepartmentService } from "./../services/department.service";
import { Permission } from "../../common/enums/permission.enum";
import { CommonService } from "../../shared/services/common.service";
import { CommonMessage } from "../common/common-messages";
import { DeleteModal } from "../models/delete-modal";
import { TicketTabInfo } from "../models/tickets-tab.model";
import { DistributorInfo } from "../interface/ticketingsystem/distributor-info";
import * as moment from 'moment';
import { environment } from "../../../environments/environment";
import { AccessLevel } from "../../common/enums/access-level.enum";
import { OperatingCountryEnums } from "../enums/countries.enums";
import { MemberTypeEnum } from "../enums/member-type.enum";

@Component({
    selector: "customer-ticket",
    templateUrl: "../templates/template1/views/tickets.component.html",
    styleUrls: [
        "../templates/template1/themes/default/css/ticket.less"
    ],
    providers: [AuthorizationPipe]
})

export class TicketsComponent implements OnInit {
    @Input() inputid: string;
    @Input() fboid: string;
    @Input() distributorInfo: DistributorInfo;
    @ViewChild('ticketType') ticketType: ElementRef;
    // Create Ticket Event Emitter
    @Output() onCreateTicket: EventEmitter<any> = new EventEmitter<any>();
    @Output() onActiveTicketTab: EventEmitter<any> = new EventEmitter<any>();
    _id: string; // stores fbo id or userName
    FBOManageTicketPermissions: any[] = [
        Permission.MANAGE_TICKETS_CREATE,
        Permission.MANAGE_DEPARTMENT_TICKETS_ASSIGN,
        Permission.MANAGE_TICKETS_ADD_NOTE_ATTACHMENT,
        Permission.MANAGE_TICKETS_VIEW
    ];

    viewCreateTicket = false;
    sourceTypes: any[];
    ticketPriorities: any[];
    ticketTypes: any[];
    subTypes: any[];
    countryMap: any;
    statusTypes: any[];
    priorityTypes: any[];
    userInfo: any;
    userId: any;
    myTickets: any[] = new Array<WorkTicket>();
    tickets: WorkTicket[] = [];
    ticketSearchModel: any;
    isSearch: boolean;
    showAllTickets: boolean = true;
    showTeamTickets: boolean = false;
    ticketTypeOnSelectAll: boolean = true;
    departmentOnSelectAll: boolean = true;
    departmentOnDeSelect: boolean = true;
    departmentOnSelect:boolean=true;
    sourceOnSelectAll: boolean = true;
    statusOnSelectAll: boolean = true;
    subTypeOnSelectAll: boolean = true;
    priorityOnSelectAll: boolean = true;
    tabId: number = 1;
    departments: any[];
    searchRequest: SearchRequest;       // API request model
    searchCriteria: any;    // Key & value model
    searchCriteriaList: SearchCriteria[];   //list of search criteria
    searchStr: string;
    isLoading: boolean = false;
    isSearchClicked: boolean = false;

    pageNumber: number = 1;
    pageSize: number = 25;
    pageCount: number = 0;
    isDesc: boolean = true;
    pageSizes: number[] = [10, 25, 50, 75];

    sortColumn: string = "TICKET_NUMBER";
    sort: string = "DESC";

    isTicketCreate: boolean;
    isTicketAssign: any;
    isTicketAddNoteNotes: boolean;
    isTicketView: boolean;
    operatingCountries: any;
    countryId: number;

    deleteModal: DeleteModal;

    memberTypeEnum = MemberTypeEnum;
    /**
     * Pagination instance - to avoid console warnings - inorder to assign id for pagination
     */
    public paginationInstance: PaginationInstance = {
        id: 'fbo-tickets-pagination',
        itemsPerPage: 10,
        currentPage: 1
    };
    public dropdownSettings: any = {
        sourceDropdownList: [],
        sourceSelectedItems: [],
        sourceIndex: 1,
        typeDropdownList: [],
        typeSelectedItems: [],
        typeIndex: 2,
        subTypeDropdownList: [],
        subTypeSelectedItems: [],
        subTypeIndex: 3,
        statusDropdownList: [],
        statusSelectedItems: [],
        statusIndex: 4,
        settings: {},
        departmentIndex: 5,
        departmentDropdownList: [],
        priorityIndex: 6,
        priorityDropdownList: [],
    };
    constructor(private messageService: MessageService,
        private _localStorageService: LocalStorageService,
        private departmentService: DepartmentService,
        private _commonService: CommonService,
        private _customerservice: CustomerService,
        private renderer: Renderer, private  chRef:  ChangeDetectorRef) {

    }
    ngOnInit(): void {
        if (environment.dataLayer && environment.dataLayer.length > 0) {
            environment.dataLayer[0].pageCategory = 'csp-tickets';
        }
        this.setFocusToTextBox();
        this.intializeMultiselectDropdowns();
        this.renderer.invokeElementMethod(this.ticketType.nativeElement, 'focus');
        this._id = this.fboid;
        this.userInfo = this._localStorageService.get("UserInfo");
        this.ticketSearchModel = new SearchModel;
        this.isTicketCreate = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[0] + "]"),AccessLevel.Customer_Service);
        this.isTicketAssign = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[1] + "]"),AccessLevel.Customer_Service);
        this.isTicketAddNoteNotes = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[2] + "]"),AccessLevel.Customer_Service);
        this.isTicketView = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[3] + "]"),AccessLevel.Customer_Service);
        this.countryId = this.getAllowedCountries();
        this.getOperatingCountries();
        this.getTicketTypesAndSubTypes();
        this.getSourceTypes();
        this.getTicketStatus();
        this.showAllTickets = true;
        this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this),
            this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.deleteModal.viewActionButtons = false;
        this.getDepartments();
        this.getTicketPriorities();
        this.subTypesSort();
        this.ticketTypesSort();

        const ticketTypeElement = document.getElementById('ticketType');
        if (ticketTypeElement) {
            ticketTypeElement.focus();
        }
    };
    doNotRemoveFormData() {
        //data should not be removed...
    } 
    openDropDown(element:string) {
        var elem = document.getElementById(element)
        var dropDownList = elem.children[0].children[1];
        dropDownList.removeAttribute("hidden");
    }
    onDropDowneBlur(element:string) {
        var elem = document.getElementById(element);
        var dropDownList = elem.children[0].children[1];
        dropDownList.setAttribute("hidden", "true");
    }
    goToViewTicket(id: any, ticketNumber: any) {

        if (this.isTicketView) {
            let ticketTab = new TicketTabInfo();
            ticketTab.distributorID = this.fboid;
            ticketTab.isNewTicket = false;
            ticketTab.ticketID = id;
            ticketTab.title = ticketNumber; //"View Ticket - "+
            ticketTab.viewTicket = true;
            this.messageService.setCustomerServiceUserTabContent(ticketTab);
        }
        else {
            this.displayAlertbox();
        }
    }

    getTicketPriorities() {
        this._customerservice.getTicketPriorities().subscribe((response) => {
            if (response) {
                this.ticketPriorities = response;
                this.ticketPriorities.sort(function (item1, item2) {
                    var priority1 = item1.value.toLowerCase(), priority2 = item2.value.toLowerCase()
                    if (priority1 < priority2) //sort string ascending
                        return -1
                    if (priority1 > priority2)
                        return 1
                    return 0
                });
                this.ticketPriorities.forEach(item => {
                    this.dropdownSettings.priorityDropdownList.push({ id: item.id, itemName: item.value });
                });
                this.dropdownSettings.prioritySelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.priorityDropdownList));
            }
        });
    }
    getDepartments() {
        this._customerservice.getAllDepartmentsByOperatingCountryId(this.countryId).subscribe((response) => {
            if (response) {
                this.departments = response;
                this.departments.sort(function (item1, item2) {
                    var dept1 = item1.value.toLowerCase(), dept2 = item2.value.toLowerCase()
                    if (dept1 < dept2) //sort string ascending
                        return -1
                    if (dept1 > dept2)
                        return 1
                    return 0
                });
                if (!this.userInfo.hasSystemRole) {
                    if (this.userInfo.privileges.departments && this.userInfo.privileges.departments.length > 0) {
                        let departmentIds = this.userInfo.privileges.departments.map(function (a: any) { return a.id; });
                        this.departments = this.departments.filter(function (item) {
                            return departmentIds.indexOf(item.id) != -1;
                        });
                    }
                }
                this.departments.forEach(item => {
                    this.dropdownSettings.departmentDropdownList.push({ id: item.id, itemName: item.value });
                });
                this.dropdownSettings.departmentSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.departmentDropdownList));
            }
        });
    }
    /**
    * display alert box if the logged in user do not have permission to see the fbo/retail information
    */
    displayAlertbox() {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.noPermissionMessage;
    }
    sortTableByColumn(sortColumn: string) {
        // this.pageNumber = 1;
        this.isDesc = (this.sortColumn == sortColumn) ? !this.isDesc : this.isDesc;
        this.sort = this.isDesc ? "DESC" : "ASC";
        this.sortColumn = sortColumn;
        //added this condition not to hit service if there are no items in grid.
        if (this.myTickets.length === 0) {
            return;
        }
        this.getTicketsSearch();

    }
   
    intializeMultiselectDropdowns() {
        
        this.dropdownSettings.sourceDropdownList = [];
        this.dropdownSettings.sourceSelectedItems = [];
        this.dropdownSettings.typeDropdownList = [];
        this.dropdownSettings.typeSelectedItems = [];
        this.dropdownSettings.subTypeDropdownList = [];
        this.dropdownSettings.subTypeSelectedItems = [];
        this.dropdownSettings.statusDropdownList = [];
        this.dropdownSettings.statusSelectedItems = [];
        this.dropdownSettings.departmentDropdownList = [];
        this.dropdownSettings.departmentSelectedItems = [];
        this.dropdownSettings.priorityDropdownList = [];
        this.dropdownSettings.prioritySelectedItems = [];

        this.dropdownSettings.settings = {
            text: "Select..",
            selectAllText: 'Select All',
            unSelectAllText: 'Select All',
            classes: "myclass custom-class",
            badgeShowLimit: 1,
        };
    }

    getTicketTypesAndSubTypes() {
        
        this.departmentService.getTicketTypesAndSubTypes(this.countryId).subscribe(response => {
            if (response) {
                this.ticketTypes = response;
                this.ticketTypes.forEach(item => {
                    this.dropdownSettings.typeDropdownList.push({ id: item.id, itemName: item.value.trim() });
                    if(item.value.trim().includes('FLP360')){
                        item.subTypes.forEach((subType: any) => {
                            let subTypeName =  subType.name.trim()+'('+ item.value.trim()+')';
                            this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                        });
                    }
                    else{
                        item.subTypes.forEach((subType: any) => {
                            this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name });
                        });
                    }
                    this.dropdownSettings.subTypeSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.subTypeDropdownList));
                });
                this.dropdownSettings.typeDropdownList.sort(function (item1, item2) {
                    var tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase()
                    if (tickettype1 < tickettype2) //sort string ascending
                        return -1
                    if (tickettype1 > tickettype2)
                        return 1
                    return 0
                });
                this.dropdownSettings.subTypeDropdownList.sort(function (item1, item2) {
                    var ticketsubtype1 = item1.itemName.toLowerCase(), ticketsubtype2 = item2.itemName.toLowerCase()
                    if (ticketsubtype1 < ticketsubtype2) //sort string ascending
                        return -1
                    if (ticketsubtype1 > ticketsubtype2)
                        return 1
                    return 0
                });
                this.dropdownSettings.typeSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.typeDropdownList));

            }
        });
    }
    getSourceTypes() {
        this._customerservice.getSourceTypes().subscribe((response) => {
            if (response) {
                this.sourceTypes = response;
                this.sourceTypes.sort(function (item1, item2) {
                    var source1 = item1.value.toLowerCase(), source2 = item2.value.toLowerCase()
                    if (source1 < source2) //sort string ascending
                        return -1
                    if (source1 > source2)
                        return 1
                    return 0
                });
                this.sourceTypes.forEach(item => {
                    this.dropdownSettings.sourceDropdownList.push({ id: item.id, itemName: item.value });
                });
                this.dropdownSettings.sourceSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.sourceDropdownList));
            }
        });
    }

    getTicketStatus() {
        this._customerservice.getTicketStatus().subscribe((response) => {
            if (response) {
                this.statusTypes = response;
                this.statusTypes.sort(function (item1, item2) {
                    var status1 = item1.value.toLowerCase(), status2 = item2.value.toLowerCase()
                    if (status1 < status2) //sort string ascending
                        return -1
                    if (status1 > status2)
                        return 1
                    return 0
                });
                this.statusTypes.forEach(item => {
                    this.dropdownSettings.statusDropdownList.push({ id: item.id, itemName: item.value });
                });
                this.dropdownSettings.statusSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.statusDropdownList));
            }
        });
    }

    getSubTypes(ticketTypeId: any) {
        if (ticketTypeId && ticketTypeId !== "undefined") {
            let types: any[] = JSON.parse(JSON.stringify(this.ticketTypes))
            this.subTypes = types.find(item => item.id === ticketTypeId).subTypes;
        } else {
            this.subTypes = [];
        }
    }
    updatePaginationVariables() {
        this.pageNumber = 1;
        this.pageSize = 10;
        this.pageCount = 0;
        this.isDesc = false;
        this.sort = this.isDesc ? "DESC" : "ASC";
    }

    createTicket() {
        // this.onCreateTicket.emit();
        let ticketTab = new TicketTabInfo();
        ticketTab.distributorID = this.fboid;
        ticketTab.isNewTicket = true;
        ticketTab.title = "Create Ticket";
        this.messageService.setCustomerServiceUserTabContent(ticketTab);
        //this.tabId++;
    }
    /**
      * On Page change 
      * @param pageNumber 
      */
    pageChange(pageNumber: number) {
        if (!isNaN(pageNumber)) {
            this.pageNumber = pageNumber;
            this.getTicketsSearch();

        }
    }
   /**
    * search with ticket number
    */
    searchWithTicketNumber() {
        if (this.ticketSearchModel.ticketNumber) {           
            this.dropdownSettings.settings = {...this.dropdownSettings.settings,disabled:true};
            this.chRef.detectChanges();
            this.dropdownSettings.statusSelectedItems=this.dropdownSettings.statusDropdownList;
            this.OnTabSearchFocus();
        } else {
            this.dropdownSettings.settings = {...this.dropdownSettings.settings,disabled:false};
            this.chRef.detectChanges();
        }
    }
    onSearch() {
        this.pageNumber = 1;
        if(this.operatingCountries){
            this.countryMap = new Map();
            this.operatingCountries.forEach(country => {
                this.countryMap.set(country.id,country.name);
            });
            this.getTicketsSearch();
        }
        
    }
    getTicketsSearch() {
        if (this.fboid) {
            this.isLoading = true;
                this._customerservice.SearchTicketsOnPagination((this.fboid), null, this.ticketSearchModel.ticketNumber,
                    (this.isSearchClicked && this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0 && !this.ticketSearchModel.ticketNumber? this.dropdownSettings.typeSelectedItems.map((item: any) => item.id) : []),
                    (this.isSearchClicked && this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length > 0 && !this.ticketSearchModel.ticketNumber ? this.dropdownSettings.subTypeSelectedItems.map((item: any) => item.id) : []),
                    (this.isSearchClicked && this.dropdownSettings.sourceSelectedItems && this.dropdownSettings.sourceSelectedItems.length > 0 && !this.ticketSearchModel.ticketNumber? this.dropdownSettings.sourceSelectedItems.map((item: any) => item.id) : []),
                    (this.isSearchClicked && this.dropdownSettings.departmentSelectedItems && this.dropdownSettings.departmentSelectedItems.length > 0 && !this.ticketSearchModel.ticketNumber? this.dropdownSettings.departmentSelectedItems.map((item: any) => item.id) : []),
                    (this.isSearchClicked && this.dropdownSettings.statusSelectedItems.map((item: any) => item.id)),
                    (this.isSearchClicked && this.dropdownSettings.prioritySelectedItems && this.dropdownSettings.prioritySelectedItems.length > 0 ? this.dropdownSettings.prioritySelectedItems.map((item: any) => item.id) : []),
                    this.pageNumber, this.pageSize, this.sortColumn, this.sort).subscribe((response: WorkTicket[]) => {
                        if (response) {
                            this.pageCount = response["totalCount"];
                            this.myTickets = response["content"];
                            if (this.myTickets && this.myTickets.length) {
                                this.myTickets.forEach(x => {
                                    x.operatingCountryName = this.countryMap.get(x.operatingCountryId);
                                    if (x.dueDate) {
                                        x.dueDate = moment.utc(x.dueDate)
                                            .utcOffset(0).format('DD-MMM-YYYY');
                                    }
                                    if (x.createdDate) {
                                        x.createdDate = moment.utc(x.createdDate)
                                            .utcOffset(0).format('DD-MMM-YYYY');
                                    }
                                    if (x.modifiedDate) {
                                        x.modifiedDate = moment.utc(x.modifiedDate)
                                            .utcOffset(0).format('DD-MMM-YYYY');
                                    }
                                });
                            }
                            this.isLoading = false;
                        } else {
                            this.pageCount = 0;
                            this.myTickets = [];
                            this.isLoading = false;
                        }
                    });
        }
    }
    onItemSelect(item: any, indexValue: any) {

        if (this.dropdownSettings.typeIndex === +indexValue) {
            if (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0) {
                let selectedIds: any[] = this.dropdownSettings.typeSelectedItems.map((index: any) => index.id)
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
                this.ticketTypes.filter(item => selectedIds.some(index => index === item.id)).forEach(type => {
                    this.ticketTypesSort();
                    if(type.value.trim().includes('FLP360')){
                        type.subTypes.forEach((subType: any) => {
                            let subTypeName =  subType.name.trim()+'('+ type.value.trim()+')';
                            this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                            this.ticketTypeOnSelectAll = false;
                        });
                    }
                    else{
                        type.subTypes.forEach((subType: any) => {
                            this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name });
                            this.ticketTypeOnSelectAll = false;
                        });
                    }
                });
                 if(this.ticketTypes.length === this.dropdownSettings.typeSelectedItems.length){
                          this.ticketTypeOnSelectAll =true;
                         }
                      else{
                        this.ticketTypeOnSelectAll =false;
                   } 
            }
        }

        else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
             if(this.statusTypes.length === this.dropdownSettings.statusSelectedItems.length){
                     this.statusOnSelectAll=true;
               }
        }
        else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = false;
               if(this.sourceTypes.length === this.dropdownSettings.sourceSelectedItems.length){
                     this.sourceOnSelectAll=true;
               }
        }
        else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = false;
            this.subTypesSort();
               if(this.dropdownSettings.subTypeDropdownList.length===this.dropdownSettings.subTypeSelectedItems.length){
                     this.subTypeOnSelectAll=true;
                     this.subTypesSort();
                    }
                 else{
                    this.subTypeOnSelectAll=false;
               }
        }
        else if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.departmentOnSelectAll = false;
              if(this.departments.length === this.dropdownSettings.departmentSelectedItems.length){
                     this.departmentOnSelectAll=true;
                   }

        }
        else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = false;
              if(this.ticketPriorities.length === this.dropdownSettings.prioritySelectedItems.length){
                    this.priorityOnSelectAll=true;
                   }
        }


    }
    onItemDeSelect(item: any, indexValue: any) {
         if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
        }
        if (this.dropdownSettings.typeIndex === +indexValue) {
            if (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0) {
                let selectedIds: any[] = this.dropdownSettings.typeSelectedItems.map((index: any) => index.id)
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
                this.ticketTypes.filter(item => selectedIds.some(index => index === item.id)).forEach(type => {
                    this.subTypesSort(); 
                    if(type.value.trim().includes('FLP360')){
                        type.subTypes.forEach((subType: any) => {
                            let subTypeName =  subType.name.trim()+'('+ type.value.trim()+')';
                            this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                            this.ticketTypeOnSelectAll = false;
                            this.ticketTypesSort();
                        });
                    }
                    else{
                        type.subTypes.forEach((subType: any) => {
                            this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name });
                            this.ticketTypeOnSelectAll = false;
                            this.ticketTypesSort();
                        });
                    }
                });
            }
            else {
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
            }
        }
        else if (this.dropdownSettings.typeIndex === +indexValue) {
            this.departmentOnSelect = false;
        }
        else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = false;
        }
        else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = false;
            this.subTypesSort();
        }
        else if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.departmentOnSelectAll = false;

        }
        else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = false;
        }
        else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
        }
        
    }
    onSelectAll(items: any, indexValue: any) {
        if (this.dropdownSettings.typeIndex === +indexValue) {
            this.dropdownSettings.subTypeDropdownList = [];
            this.dropdownSettings.subTypeSelectedItems = [];
            this.ticketTypes.forEach(type => {
                this.ticketTypesSort();
                if(type.value.trim().includes('FLP360')){
                    type.subTypes.forEach((subType: any) => {
                        this.subTypesSort();
                        let subTypeName =  subType.name.trim()+'('+ type.value.trim()+')';
                        this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                    });
                }
                else{
                    type.subTypes.forEach((subType: any) => {
                        this.subTypesSort();
                        this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name });
                    });
                }
            });
            this.ticketTypeOnSelectAll = true;
        }
        else if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.departmentOnSelectAll = true;

        }
        else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = true;
        }

        else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = true;
            this.subTypesSort();
        }
        else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = true;
        }
        else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = true;
        }
    }
    onDeSelectAll(items: any, indexValue: any) {
        if (this.dropdownSettings.typeIndex === +indexValue) {
            this.dropdownSettings.subTypeDropdownList = [];
            this.dropdownSettings.subTypeSelectedItems = [];
            this.ticketTypeOnSelectAll = false;
            this.ticketTypesSort();
        }
        else if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.departmentOnSelectAll = false;
        }
        else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
        }
        else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = false;
            this.ticketTypesSort();
        }
        else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = false;
        }
        else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = false;
        }
    }

    setFocusToTextBox() {
        setTimeout(function() {
            const ticketTypeElement = document.getElementById("ticketType");
            if (ticketTypeElement) {
                ticketTypeElement.focus();
            }
         }, 1000);
    }

    OnTabEventRecentlyViewed()
    {
        const ticketTypeElement = document.getElementById("ticketType");
        if (ticketTypeElement) {
            ticketTypeElement.focus();
        }
        event.preventDefault();
    }
    OnTabSearchFocus(){
        const searchButtonElement = document.getElementById("searchbutton");
        if (searchButtonElement) {
            searchButtonElement.focus();
        }
        event.preventDefault();
    }

    clearFields(){
        this.dropdownSettings.settings = {...this.dropdownSettings.settings,disabled:false};
        this.chRef.detectChanges();
        this.setFocusToTextBox();
        this.intializeMultiselectDropdowns();
        this.renderer.invokeElementMethod(this.ticketType.nativeElement, 'focus');
        this._id = this.fboid;
        this.userInfo = this._localStorageService.get("UserInfo");
        this.ticketSearchModel = new SearchModel;
        this.isTicketCreate = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[0] + "]"),AccessLevel.Customer_Service);
        this.isTicketAssign = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[1] + "]"),AccessLevel.Customer_Service);
        this.isTicketAddNoteNotes = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[2] + "]"),AccessLevel.Customer_Service);
        this.isTicketView = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[3] + "]"),AccessLevel.Customer_Service);
        this.getTicketTypesAndSubTypes();
        this.getSourceTypes();
        this.getTicketStatus();
        this.onSearch();
        this.showAllTickets = true;
        this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this),
        this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.deleteModal.viewActionButtons = false;
        this.getDepartments();
        this.getTicketPriorities();

        const ticketTypeButton = document.getElementById('ticketType');
        if (ticketTypeButton) {
            ticketTypeButton.focus();
        }
        this.ticketTypeOnSelectAll =true;
        this.statusOnSelectAll = true;
        this.sourceOnSelectAll = true;
        this.subTypeOnSelectAll = true;
        this.departmentOnSelectAll = true;
        this.priorityOnSelectAll = true;
        this.isSearchClicked = false;
    }
    subTypesSort(){
        this.dropdownSettings.subTypeDropdownList.sort(function (item1, item2) {
            var tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase()
            if (tickettype1 < tickettype2) //sort string ascending
                return -1
            if (tickettype1 > tickettype2)
                return 1
            return 0
        });
     }
     ticketTypesSort(){
        this.dropdownSettings.typeDropdownList.sort(function (item1, item2) {
            var tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase()
            if (tickettype1 < tickettype2) //sort string ascending
                return -1
            if (tickettype1 > tickettype2)
                return 1
            return 0
        });
     }
     getOperatingCountries() {
        this._customerservice.getAllBusinessEntities().subscribe((response: any) => {
            if (response) {
                this.operatingCountries = response;
                this.onSearch();
                let countryInfo = this.operatingCountries.find((country:any) =>  country.id === this.countryId);
                //let countryInfo = {id : 0, name : this.fieldTypes.ALL, value:this.fieldTypes.ALL };
                if(countryInfo){
                    this.operatingCountries.splice( this.operatingCountries.indexOf(countryInfo), 1 );
                    this.operatingCountries.splice(0, 0, countryInfo);
                }
            }
            
        });
    }

    getAllowedCountries() {
        let countryIds: any = [];
        if (!this.userInfo.hasSystemRole) {
            if (this.userInfo.allowedOperatingCountries) {
                countryIds = this.userInfo.allowedOperatingCountries.split(",");
                countryIds.sort(function (id1, id2) {
                    if (id1 < id2) //sort string ascending
                        return -1
                    if (id1 > id2)
                        return 1
                    return 0
                });
                return countryIds[0];   
            }
        }
        return OperatingCountryEnums.USA;
    }
    ShowTicketAndDepatrmentBycountry(countryId){
        this.countryId = countryId;
        this.dropdownSettings.typeDropdownList=[];
		this.dropdownSettings.subTypeDropdownList=[];
		this.dropdownSettings.subTypeSelectedItems=[];
        this.dropdownSettings.typeSelectedItems= [];
        this.departments=[];
        this.dropdownSettings.departmentDropdownList=[];
        this.dropdownSettings.departmentSelectedItems=[];
        this.dropdownSettings.assignedToDropdownList=[];
        this.dropdownSettings.assignedToSelectedItems=[];
        this.getTicketTypesAndSubTypes();
        this.getDepartments();
    }
    
   

}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/tickets.component.ts